<template>
  <div class="container">
    <!-- <BaseLoader
      v-if="cargando"
    /> -->
    <!-- <table v-else> -->
    <table id="tabla-stock">
      <thead>
        <th>Nombre</th>
        <th>Ubicación</th>
        <th class="no-borde">Distribución</th>
        <th class="nofuente gradient_2">ACCIONES</th>
      </thead>
      <tbody>
        <PuntosDeEntregaListaItem
          v-for="punto in puntos"
          :punto="punto"
          :key="punto.persona_id"
          @refrescar="refrescarStock"
        ></PuntosDeEntregaListaItem>
      </tbody>
    </table>
  </div>
</template>

<script>
import PuntosDeEntregaListaItem from '../components/PuntosDeEntregaListaItem.vue'
// import Header2 from '../components/Header2.vue'
import productosService from '../services/productos'
export default {
  name: 'PuntosDeEntregaLista',
  components: {
    PuntosDeEntregaListaItem
    // Header2
  },
  data: function () {
    return {
      puntos: []
    }
  },
  methods: {
    refrescarStock () {
      productosService
        .traerProductosTodosConStock()
        .then(respuesta => {
          // this.cargando = false
          this.puntos = respuesta
        })
    }
  },
  mounted: function () {
    // this.cargando = true
    productosService
      .traerProductosTodosConStock()
      .then(respuesta => {
        // this.cargando = false
        this.puntos = respuesta
        console.log('Todas los puntos de entrega con stock', respuesta)
      })
  }
}
</script>

<style>

</style>
